var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",class:_vm.className,attrs:{"disabled":_vm.disabled},on:{"click":_vm.action}},[(_vm.loading)?[_vm._t("loader")]:[_vm._t("prepend"),_vm._t("default",function(){return [_vm._v("Button")]}),_vm._t("append")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }